var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4a4 4 0 118 0 4 4 0 01-8 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M4 0a4 4 0 100 8 4 4 0 000-8zm1.29 4c0 .711-.579 1.29-1.29 1.29-.711 0-1.29-.579-1.29-1.29 0-.711.579-1.29 1.29-1.29.711 0 1.29.579 1.29 1.29z"
  })));
}
export default SvgStopPin;